import { modelJson, weightBundles } from "../model_imports/inception_v3.js";
export var InceptionV3Model = {
    name: "InceptionV3",
    numOfWeightBundles: 6,
    options: { size: 299 },
    modelJson: modelJson,
    weightBundles: weightBundles,
};
//# sourceMappingURL=inception_v3.js.map